import { render } from "./Produk.vue?vue&type=template&id=729f241f&scoped=true"
import script from "./Produk.vue?vue&type=script&lang=js"
export * from "./Produk.vue?vue&type=script&lang=js"

import "./Produk.vue?vue&type=style&index=0&id=729f241f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-729f241f"]])

export default __exports__